<div class="disclaimer-bar rounded d-flex align-items-center">
    <img
        [src]="'assets/img/' + image() + '.svg'"
        alt="credit image"
        [style.max-width.px]="imageConfig().width"
        [style.max-height.px]="imageConfig().height"
    />
    <p class="mb-0 align-self-center">{{ text() }}</p>
</div>
